import React from 'react';
import { Text, Title } from 'dig-components/typography';
import { BowlEmptySpot } from 'dig-illustrations/dist/cjs/spot/bowl-empty';
import { DogDigsSpot } from 'dig-illustrations/dist/cjs/spot/dog-digs';
import { FormattedMessage } from 'react-intl';
import styles from './select-template-modal.scss';
import Spacer, { SpacerSize } from 'hellospa/foundation/spacing/spacer';


const kinds = {
  beforeSearch: {
    heading: (
      <FormattedMessage
        id=""
        description="text for the search page"
        defaultMessage="Start typing to search" />
    ),
    subHeading: (

      <FormattedMessage
        id=""
        description="text for the search page"
        defaultMessage="Try a template name, creator, or keyword" />
    ),
    illustration: <DogDigsSpot />,
  },
  noResults: {
    heading: (

      <FormattedMessage
        id=""
        description="Search page text"
        defaultMessage="No results found" />
    ),
    subHeading: (

      <FormattedMessage
        id=""
        description="Search page text"
        defaultMessage="Try searching for different words" />
    ),
    illustration: <BowlEmptySpot />,
  },
};


type Props = {
  kind: keyof typeof kinds
}
export const SearchZeroState = ({ kind }: Props) => {
  const { heading, subHeading, illustration } = kinds[kind];

  return (
    <div className={styles.searchingZeroState}>
      <Title>{heading}</Title>
      <Spacer below={SpacerSize.XL}>
        <Text variant="paragraph" color="standard" size='standard'>
          {subHeading}
        </Text>
      </Spacer>

      <div className={styles.dogDig} >
        {illustration}
      </div>
    </div>


  );
};
